import { LogEventType } from '@akin-home/amplify';
import { DeleteRecordLogEvent } from '@akin-home/logging';
import { postLogEvent, PostLogEventParams } from './postLogEvent';

type Params = Omit<PostLogEventParams<DeleteRecordLogEvent['data']>, 'type'>;

export const postDeleteRecordLogEvent = (params: Params) =>
  postLogEvent({
    ...params,
    type: LogEventType.DELETE_RECORD,
  });
